interface Country {
  countryCode: string;
  countryText: string;
  states: State[];
}
interface State {
  stateCode: string;
  stateText: string;
}
interface DropDownData {
  name: string;
  value: string;
}
interface DropDownState {
  name: string;
  state: DropDownData[]
}
export default class ManageBrandingService {
  public static COUNTRIES: DropDownData[] = [];
  public static STATES: DropDownState[] = [];

  public static setCountryState(countryList: Country[]): void {
    ManageBrandingService.setCountry(countryList);
    ManageBrandingService.setState(countryList);
  }

  public static setCountry(countryList: Country[]): void {
    ManageBrandingService.COUNTRIES.length = 0;
    countryList.forEach((country: Country) => {
      ManageBrandingService.COUNTRIES.push({
        name: country.countryText,
        value: country.countryCode,
      } as DropDownData);
    });
  }

  public static setState(countryList: Country[]): void {    
    ManageBrandingService.STATES.length = 0;
    countryList.forEach((country: Country) => {
      const stateData: DropDownState = {
        name: "",
        state: [],
      };
      stateData.name = country.countryCode;
      if (country.states) {
        country.states.forEach((state: State) => {
          stateData.state.push({
            name: state.stateText,
            value: state.stateCode,
          });
        });
      }
      ManageBrandingService.STATES.push(stateData);
    });
  }
}
